import React, { useEffect, useState } from 'react';
import PageLayout from 'components/layouts/PageLayout';
import NewButton from 'components/input/NewButton';
import { UserInfoDto } from 'services/data-contracts';
import ServiceHelper from 'stores/ServiceHelper';
import styled from 'styled-components';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import { Row } from 'saladsoft-primitive';
import Text from 'components/commons/Text';
import { useStoreWrapper } from 'stores/StoreHelper';
import MemberForm from 'components/pages/member/MemberForm';

const UserManagementPage = () => {
  const { uiStore } = useStoreWrapper();

  const [members, setMembers] = useState<UserInfoDto[]>([]);

  const fetchMembers = () => {
    ServiceHelper.adminMemberService?.getAdminMembers().then((res) => {
      setMembers(res.data);
    });
  };

  const handleClickMember = (member?: UserInfoDto) => {
    uiStore?.modal.show({
      style: { width: 800, height: '100%', maxHeight: '60vh' },
      title: member?.id ? member?.profile?.lastName + '님의 정보' : '사용자 추가',
      children: <MemberForm member={member} onSave={() => fetchMembers()} />,
    });
  };

  useEffect(() => {
    fetchMembers();
  }, []);
  return (
    <PageLayout
      title="사용자관리"
      actionButton={
        <NewButton
          onClick={() => {
            handleClickMember();
          }}
        >
          사용자추가
        </NewButton>
      }
    >
      <Row width="100%" gap={20} flexWrap="wrap" justifyContent="flex-start">
        {members.map((member) => (
          <UserCardWrapper
            disabled={member.isWithdrawn}
            key={member.id}
            onClick={() => {
              handleClickMember(member);
            }}
          >
            {member.isWithdrawn && <WidthDrawWrapper>비활성</WidthDrawWrapper>}
            <Row gap={10}>
              <AccountCircleOutlinedIcon />
              <Text>
                {member.profile?.lastName}
                {member.profile?.firstName}
              </Text>
            </Row>
          </UserCardWrapper>
        ))}
      </Row>
    </PageLayout>
  );
};

const UserCardWrapper = styled.div<{ disabled?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 10px;
  width: 300px;
  height: 100px;
  cursor: pointer;
  ${({ disabled }) =>
    disabled &&
    `

  `}
`;

const WidthDrawWrapper = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: #f00;
  color: #fff;
  padding: 5px;
  border-radius: 5px;
`;

export default UserManagementPage;
